import React, { useState } from "react";

/**
 * Tolerant team-crest renderer.
 * - Sets referrerPolicy="no-referrer" so hot-linking from Wikipedia/CDNs that
 *   reject Referer-based requests still works.
 * - On error falls back to the first letter(s) of the team name on a coloured tile.
 *
 * Props: src, alt (team name), size (number, px), bg (optional bg color)
 */
export default function TeamLogo({ src, alt = "", size = 48, bg = "#0a0a0a", className }) {
  const [failed, setFailed] = useState(false);
  const initials = (alt || "?").split(/\s+/).slice(0, 2).map((w) => w[0]).join("").toUpperCase().slice(0, 2);

  if (!src || failed) {
    return (
      <div
        className={className}
        style={{
          width: size, height: size,
          background: bg,
          border: "1px solid rgba(255,255,255,0.1)",
          display: "flex", alignItems: "center", justifyContent: "center",
          color: "var(--qv-red)", fontFamily: "Bebas Neue",
          fontSize: Math.max(12, Math.round(size * 0.42)),
          letterSpacing: "0.02em",
          flexShrink: 0,
        }}
        aria-label={alt}
      >
        {initials || "?"}
      </div>
    );
  }
  return (
    <img
      src={src}
      alt={alt}
      onError={() => setFailed(true)}
      referrerPolicy="no-referrer"
      loading="lazy"
      className={className}
      style={{ width: size, height: size, objectFit: "contain", background: bg, flexShrink: 0 }}
    />
  );
}
